import { useLazyQuery, useQuery } from "@apollo/client";
import { ORDERS } from "../order.queries";
import { OrdersQuery, OrdersQueryVariables } from "../../../__generated__/OrdersQuery";

export const useOrders = (variables: OrdersQueryVariables) => {
  return useQuery<OrdersQuery, OrdersQueryVariables>(ORDERS, { variables });
};

export const useLazyOrders = () => {
  return useLazyQuery<OrdersQuery, OrdersQueryVariables>(ORDERS);
};
